<div *ngIf="group" [formGroup]="group" class="form-group">
    <label *ngIf="textLabel" [for]="fcName+i" class="label-info" [ngClass]="{'star' : required}">{{textLabel}} </label>
    <select [disabled]="disabled"
            [formControlName]="fcName"
            [id]="fcName + i"
            [name]="fcName + i"
            [ngClass]="{'is-invalid': (control && control.invalid && submitted)}"
            class="custom-select a">
        <option *ngFor="let item of (disabled ? [] : items)" value='{{item.id}}'>{{item.name}}</option>
    </select>
    <div *ngIf="control && control.invalid && (errorMsg)&& submitted" class="invalid-feedback">
        <div *ngIf="control.errors.required">{{errorMsg}}</div>
    </div>
</div>
<div *ngIf="!group"> <!-- Pas dans un reactive form -->
    <label *ngIf="textLabel" [for]="fcName" class="label-info" [ngClass]="{'star' : required}">{{textLabel}} </label>
    <select (ngModelChange)="change($event)"
            [disabled]="disabled"
            [id]="fcName"
            [ngModel]="modelAttribute"
            class="custom-select b">
        <option *ngFor="let item of (disabled ? [] : items)" [ngValue]="item.id">{{item.name}}</option>
    </select>
</div>


